import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { d as debounce_1 } from './index4.js';
import { H as HistoryService, S as StringService } from './index2.js';
import { D as DomService, T as TrackingService } from './index3.js';
import { T as TranslationService } from './index6.js';
import { F as FuzzinessOption } from './roche-search.types.js';
import { T as TeaserLayout } from './roche-teaser.types.js';
import { A as AccordionTabsType, a as AccordionTabsAppearance } from './roche-accordion-tabs.types.js';
import { S as StoryTeaserLayout } from './roche-story-teaser.types.js';
import { S as StoryType } from './roche-story-staging-hero.types.js';
import { A as AdobeTracking } from './index7.js';
import { d as defineCustomElement$9 } from './roche-accordion-tabs2.js';
import { d as defineCustomElement$8 } from './roche-accordion-tabs-item2.js';
import { d as defineCustomElement$7 } from './roche-anchor2.js';
import { d as defineCustomElement$6 } from './roche-headline2.js';
import { d as defineCustomElement$5 } from './roche-icon2.js';
import { d as defineCustomElement$4 } from './roche-loading-spinner2.js';
import { d as defineCustomElement$3 } from './roche-pagination2.js';
import { d as defineCustomElement$2 } from './roche-richtext2.js';

var CludoCategory;
(function (CludoCategory) {
    CludoCategory["PAGES"] = "pages";
    CludoCategory["STORIES"] = "stories";
    CludoCategory["DOCUMENTS"] = "documents";
})(CludoCategory || (CludoCategory = {}));
var TrackingType;
(function (TrackingType) {
    TrackingType["TYPING"] = "typing";
    TrackingType["FILTERING"] = "filtering";
})(TrackingType || (TrackingType = {}));

const rocheSearchCss = ".roche-search{margin-bottom:4.5rem;}.roche-search .input-container{z-index:150;position:relative;margin-top:2rem;width:100%}@media (min-width: 48rem){.roche-search .input-container{width:66.6666666667%;margin-top:3rem}}.roche-search .input-container input{font-family:\"roche-sans\";font-style:normal;font-weight:200;color:var(--color-text--primary);font-size:var(--body--font-size--small-up);line-height:1.8125rem;font-family:\"roche-sans\";font-weight:200;background-color:transparent;border:none;border-bottom:1px solid #706b69;border-radius:0;padding:0.3125rem 1.875rem 0.75rem 2.5rem;width:100%}@media (min-width: 64rem){.roche-search .input-container input{font-size:var(--body--font-size--xlarge-up);line-height:2rem}}@media (min-width: 48rem){.roche-search .input-container input{font-size:1.5625rem;line-height:2.1875rem}}@supports (-webkit-overflow-scrolling: touch){.roche-search .input-container input{-webkit-appearance:none}}.roche-search .input-container input:active,.roche-search .input-container input:hover,.roche-search .input-container input:focus{border-bottom-color:#0b41cd}.roche-search .input-container input::placeholder{color:#706b69;margin-right:0.625rem}.roche-search .input-container input:focus{outline:none}.roche-search .input-container ::-webkit-search-decoration,.roche-search .input-container ::-webkit-search-cancel-button,.roche-search .input-container ::-webkit-search-results-button,.roche-search .input-container ::-webkit-search-results-decoration{display:none}.roche-search .input-container roche-icon{fill:#706b69;position:absolute;top:0.4375rem;left:0}@media (min-width: 48rem){.roche-search .input-container roche-icon{top:0.6875rem}}.roche-search .input-container .clear-input{position:absolute;top:0.1875rem;right:1.375rem;visibility:hidden}.roche-search .input-container .clear-input:hover{cursor:pointer}.roche-search .input-container .clear-input--hidden{visibility:visible}.roche-search .search-no-results,.roche-search .search-counter,.roche-search .search-pagination{padding:4rem 0 0}.roche-search .search-no-results--hidden,.roche-search .search-counter--hidden,.roche-search .search-pagination--hidden{display:none}.roche-search .search-pagination--eight-columns{width:100%}@media (min-width: 48rem){.roche-search .search-pagination--eight-columns{width:66.6666666667%}}.roche-search .teaser-container--eight-columns{width:100%}@media (min-width: 48rem){.roche-search .teaser-container--eight-columns{width:66.6666666667%}}.roche-search .teaser-container--hidden{display:none}.roche-search roche-teaser-wall{margin:3.3125rem 0 0}@media (min-width: 64rem){.roche-search roche-teaser-wall{margin:3.375rem 0 0}}@media (min-width: 90rem){.roche-search roche-teaser-wall{margin:3.5rem 0 0}}.roche-search .load-more{display:none}@media (min-width: 20rem){.roche-search .load-more roche-loading-spinner{margin-top:0}}@media (min-width: 48rem){.roche-search .load-more roche-loading-spinner{margin-top:0}}.roche-search .load-more--active{display:block}@media (min-width: 20rem){.roche-search .load-more--active roche-loading-spinner{margin-top:8rem}}@media (min-width: 48rem){.roche-search .load-more--active roche-loading-spinner{margin-top:10rem}}.roche-search .support-content-wrapper{display:flex;flex-direction:column;margin-top:4.625rem}@media (min-width: 48rem){.roche-search .support-content-wrapper{width:66.6666666667%;flex-direction:row}}.roche-search .popular-searches{width:100%;margin-bottom:2.5rem}@media (min-width: 64rem){.roche-search .popular-searches{width:41.6666666667%;margin-bottom:0}}.roche-search .quick-links{width:100%}@media (min-width: 64rem){.roche-search .quick-links{width:58.3333333333%}}.roche-search .popular-searches__title,.roche-search .quick-links__title{font-family:\"roche-sans\";font-style:normal;font-weight:200;font-weight:400;font-size:var(--footnotes--font-size--small-up);line-height:1.1875rem;color:#544f4f}@media (min-width: 48rem){.roche-search .popular-searches__title,.roche-search .quick-links__title{font-size:var(--footnotes--font-size--medium-up)}}.roche-search ::slotted(roche-teaser){margin-top:1.5rem}:host([dir=rtl]) .input-container input{padding:0.3125rem 2.5rem 0.75rem 1.875rem}:host([dir=rtl]) .input-container roche-icon{left:auto;right:0}:host([dir=rtl]) .input-container .clear-input{left:1.375rem;right:auto}";
const RocheSearchStyle0 = rocheSearchCss;

const teaserContainersMap = {
    [CludoCategory.PAGES]: 'div',
    [CludoCategory.STORIES]: 'roche-teaser-wall',
    [CludoCategory.DOCUMENTS]: 'div',
};
const teaserComponentMap = {
    [CludoCategory.PAGES]: 'roche-teaser',
    [CludoCategory.STORIES]: 'roche-story-teaser',
    [CludoCategory.DOCUMENTS]: 'roche-teaser',
};
const teaserLayoutMap = {
    [CludoCategory.PAGES]: TeaserLayout.VARIANT_A_WITHOUT_IMAGE,
    [CludoCategory.STORIES]: StoryTeaserLayout.VARIANT_A,
    [CludoCategory.DOCUMENTS]: TeaserLayout.VARIANT_A_WITHOUT_IMAGE,
};
const RocheSearch$1 = /*@__PURE__*/ proxyCustomElement(class RocheSearch extends HTMLElement {
    triggerNewPage(event) {
        this.searchResults = [];
        this.currentPage = event.detail;
        this.querySearch();
    }
    handleToggle(event) {
        this.isLoading = true;
        if (event.detail.activeTabId && (this.currentPage === 1
            && event.detail.activeTabId !== this.currentSearchFilter)) {
            this.currentSearchFilter = event.detail.activeTabId;
            this.trackSearch();
        }
        else if (event.detail.activeTabId) {
            this.currentSearchFilter = event.detail.activeTabId;
        }
        if (event.detail.triggered && this.currentPage !== 1) {
            this.currentPage = 1;
            this.querySearch();
            this.isTabChanging = true;
        }
        this.hasLoadedPreviously = true;
        this.isLoading = false;
    }
    triggerPopularSearch(event) {
        const popularSearch = event.detail.srcElement.innerHTML;
        this.inputElement.value = popularSearch;
        this.trackingSearchComponent = 'Search Suggestion';
        this.handleChange('suggestion');
    }
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.totalResultsFoundText = undefined;
        this.inputPlaceholder = undefined;
        this.searchFilters = [
            CludoCategory.PAGES,
            CludoCategory.STORIES,
            CludoCategory.DOCUMENTS,
        ];
        this.searchTerm = undefined;
        this.searchResults = [];
        this.totalResultsFound = [];
        this.isLoading = false;
        this.resultsPerPage = 6;
        this.oldQuery = undefined;
        this.translations = undefined;
        this.currentPage = undefined;
        this.currentSearchFilter = undefined;
        this.trackingSearchComponent = 'Main Search';
        this.hasLoadedPreviously = false;
        this.isTabChanging = false;
        /*
         * To prevent race conditions on search steps (trigger, url param read, url param update, etc)
         * Keep the same debounce times for all methods which call one or more of these steps.
         */
        const searchStepDebounceTime = 500;
        this.handleUrlSearchParams = debounce_1.debounce(this.handleUrlSearchParams.bind(this), searchStepDebounceTime, false);
        this.handleChange = debounce_1.debounce(this.handleChange.bind(this), searchStepDebounceTime, false);
        this.querySearch = debounce_1.debounce(this.querySearch.bind(this), searchStepDebounceTime, false);
        this.handleClearInput = this.handleClearInput.bind(this);
    }
    async componentWillLoad() {
        this.translations = Object.assign({ inputPlaceholder: await TranslationService.translate('enter your search term'), noResultsMessage: await TranslationService.translate('please try with another term.'), noResultsTitle: await TranslationService.translate('sorry, no results found.'), popularSearches: await TranslationService.translate('popular searches:'), quickLinks: await TranslationService.translate('quick links'), resultsFound: await TranslationService.translate('results found'), search: await TranslationService.translate('search') }, await this.getTranslatedSearchFilters());
    }
    componentDidLoad() {
        /**
         * Currently, if the roche-search component is nested inside another web
         * component (e.g. a roche-grid), calling `this.inputElement.focus` inside
         * `componentDidLoad` does not work.
         * See https://github.com/ionic-team/stencil/issues/3246
         * As a workaround, we push the call to `focus` onto the message queue.
         */
        setTimeout(() => { this.inputElement.focus(); });
        this.handleUrlSearchParams();
        window.addEventListener('popstate', this.handleUrlSearchParams);
        DomService.handleTextDirection(this.element);
    }
    handleUrlSearchParams() {
        var _a, _b;
        const url = HistoryService.getActiveUrl();
        const query = url.searchParams.get(HistoryService.searchParams.cludoQuery);
        const page = url.searchParams.get(HistoryService.searchParams.cludoPage);
        if (!query) {
            this.searchResults = [];
            this.totalResultsFound = [];
            this.inputElement.value = '';
            this.currentPage = 1;
            return;
        }
        const newStateShouldTriggerNewSearch = query !== this.searchTerm
            || this.currentPage !== Number(page);
        /**
         * The new history state only updated the hash.
         * Therefore, we ensure the corresponding tab is opened and prevent any new requests to cludo.
         */
        if (!newStateShouldTriggerNewSearch) {
            (_b = (_a = this.tabs) === null || _a === void 0 ? void 0 : _a.querySelector(url.hash)) === null || _b === void 0 ? void 0 : _b.getTabIndex().then((tabIndex) => { var _a; return (_a = this.tabs) === null || _a === void 0 ? void 0 : _a.syntheticHandleToggle(tabIndex); });
            return;
        }
        this.inputElement.value = query;
        this.searchTerm = query;
        this.currentPage = Number(page);
        this.querySearch();
    }
    updateSearchParams() {
        const currentUrl = HistoryService.getActiveUrl();
        const nextUrl = HistoryService.getActiveUrl();
        nextUrl.searchParams.delete(HistoryService.searchParams.cludoPage);
        if (!this.searchTerm) {
            nextUrl.searchParams.delete(HistoryService.searchParams.cludoQuery);
        }
        else {
            nextUrl.searchParams.set(HistoryService.searchParams.cludoQuery, this.searchTerm);
        }
        nextUrl.searchParams.set(HistoryService.searchParams.cludoPage, `${this.currentPage}`);
        const [pages, stories, documents] = this.searchFilters;
        const hashValues = [pages, stories, documents];
        const firstIndexWithResults = this.totalResultsFound
            .findIndex((totalResults) => totalResults >= 1);
        const currentIndex = hashValues.indexOf(currentUrl.hash.slice(1));
        this.currentSearchFilter = hashValues[currentIndex];
        if (currentIndex === -1 || this.totalResultsFound[currentIndex] === 0) {
            nextUrl.hash = hashValues[firstIndexWithResults === -1 ? 0 : firstIndexWithResults];
            const [, currentHashFilter] = nextUrl.hash.split('#');
            this.currentSearchFilter = currentHashFilter;
        }
        if (!HistoryService.shouldParamsUpdateHistory(currentUrl, nextUrl)) {
            return;
        }
        if (this.isTabChanging) {
            this.isTabChanging = false;
            HistoryService.replaceHistory(nextUrl);
        }
        else {
            HistoryService.updateHistoryForSearch(nextUrl);
        }
    }
    render() {
        var _a, _b;
        const clearInputClasses = {
            'clear-input': true,
            'clear-input--hidden': !!this.searchTerm,
        };
        const loadMoreClasses = {
            'load-more': true,
            'load-more--active': this.isLoading,
            'teaser-container--eight-columns': true,
        };
        return (h("div", { key: '6cb41f68e78b978919d2ee62f91e60016670c438', class: "roche-search" }, h("roche-headline", { key: '357dfd0063d8ddcdf1ffd87e60a92b25b8d46bab', headline: StringService.capitalize(this.translations.search), level: 3 }), h("div", { key: 'e1a4646b751bdcf0c373f23624f1ac95fbe512d0', class: "input-container" }, h("roche-icon", { key: '0732e27f860851bfc2faf984a7f1a5a5b98f5805', icon: "search", height: "1.5rem" }), h("input", { key: '621e5e3bcede46636547ef68b918691d3c49c76c', class: "search-input", placeholder: StringService.capitalize(this.translations.inputPlaceholder), type: "search", ref: (el) => { this.inputElement = el; }, onInput: () => this.handleChange('main') }), h("span", { key: 'bd255b1dec6b9f471da71ccef94551428d1a29f3', class: clearInputClasses, onClick: this.handleClearInput }, h("roche-icon", { key: '7f575828d0f38c359db36287776ebd451287f3d5', icon: "remove", height: "1.5rem" }))), (this.totalResultsFound.length <= 0 && !this.isLoading)
            && h("div", { class: "support-content-wrapper" }, h("div", { class: "popular-searches" }, h("div", { class: "popular-searches__title" }, StringService.capitalize(this.translations.popularSearches)), h("slot", { name: "popular-search" })), h("div", { class: "quick-links" }, h("div", { class: "quick-links__title" }, StringService.capitalize(this.translations.quickLinks)), h("slot", { name: "quick-links" }))), h("div", { key: '8e7d2f2c0f681f853c00bd3e26436a2e3e11ea10', class: loadMoreClasses }, h("roche-loading-spinner", { key: '77e4b69833ce80cda572f9fcb0c58275db5650e4' }, " ")), h("roche-accordion-tabs", { key: '536c250512ddb4ed9e65888dd938399f18c68fa7', type: AccordionTabsType.TABS, refresh: !((_a = this.searchResults) === null || _a === void 0 ? void 0 : _a.length), appearance: AccordionTabsAppearance.FILTER, alwaysPersistFirstTabId: true, ref: (el) => { this.tabs = el; } }, (_b = this.searchResults) === null || _b === void 0 ? void 0 : _b.map((result, index) => {
            const filterType = this.searchFilters[index];
            const TeaserContainer = teaserContainersMap[filterType];
            const Teaser = teaserComponentMap[filterType];
            const teaserLayout = teaserLayoutMap[filterType];
            const isDownloadTeaser = filterType === CludoCategory.DOCUMENTS;
            const isSearchResultTeaser = filterType === CludoCategory.PAGES;
            const totalPages = Math.ceil(result.TotalDocument / this.resultsPerPage);
            return (h("roche-accordion-tabs-item", { key: index, type: AccordionTabsType.TABS, headline: `${StringService.capitalize(this.translations[this.searchFilters[index]])} (${this.searchResults[index].TotalDocument})`, id: this.searchFilters[index] }, h("roche-richtext", { class: {
                    'search-no-results': true,
                    'search-no-results--hidden': result.TypedDocuments.length > 0,
                } }, h("roche-headline", { headline: StringService.capitalize(this.translations.noResultsTitle), level: 4 }), h("p", null, StringService.capitalize(this.translations.noResultsMessage))), h("roche-richtext", { class: {
                    'search-counter': true,
                    'search-counter--hidden': this.totalResultsFound[index] <= 0,
                } }, h("p", null, this.getResultsFoundText(index))), h(TeaserContainer, { class: {
                    'teaser-container': true,
                    'teaser-container--eight-columns': teaserContainersMap[filterType] !== teaserContainersMap[CludoCategory.STORIES],
                    'teaser-container--hidden': this.totalResultsFound[index] <= 0,
                } }, result.TypedDocuments.map((document, i) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
                const type = ((_b = (_a = document.Fields) === null || _a === void 0 ? void 0 : _a['Story Type']) === null || _b === void 0 ? void 0 : _b.Value) === 'none'
                    ? StoryType.EMPTY
                    : (_d = (_c = document.Fields) === null || _c === void 0 ? void 0 : _c['Story Type']) === null || _d === void 0 ? void 0 : _d.Value;
                const title = ((_f = (_e = document.Fields) === null || _e === void 0 ? void 0 : _e['Teaser Title']) === null || _f === void 0 ? void 0 : _f.Value)
                    || ((_h = (_g = document.Fields) === null || _g === void 0 ? void 0 : _g.Title) === null || _h === void 0 ? void 0 : _h.Value)
                    // eslint-disable-next-line camelcase
                    || ((_k = (_j = document.Fields) === null || _j === void 0 ? void 0 : _j.fc_Title) === null || _k === void 0 ? void 0 : _k.Value)
                    // eslint-disable-next-line camelcase
                    || ((_m = (_l = document.Fields) === null || _l === void 0 ? void 0 : _l.fc_ResponseFileName) === null || _m === void 0 ? void 0 : _m.Value)
                    || StringService.capitalize(filterType);
                const description = isDownloadTeaser
                    ? (_r = (_q = StringService.getExtension((_p = (_o = document.Fields) === null || _o === void 0 ? void 0 : _o.Url) === null || _p === void 0 ? void 0 : _p.Value)) === null || _q === void 0 ? void 0 : _q.toUpperCase()) !== null && _r !== void 0 ? _r : ''
                    : ((_t = (_s = document.Fields) === null || _s === void 0 ? void 0 : _s['Teaser Description']) === null || _t === void 0 ? void 0 : _t.Value) || ((_v = (_u = document.Fields) === null || _u === void 0 ? void 0 : _u.Description) === null || _v === void 0 ? void 0 : _v.Value);
                const date = ((_x = (_w = document.Fields) === null || _w === void 0 ? void 0 : _w['Published Date']) === null || _x === void 0 ? void 0 : _x.Value) && !isSearchResultTeaser
                    ? new Date((_z = (_y = document.Fields) === null || _y === void 0 ? void 0 : _y['Published Date']) === null || _z === void 0 ? void 0 : _z.Value).toISOString()
                    : '';
                const image = ((_1 = (_0 = document.Fields) === null || _0 === void 0 ? void 0 : _0['Teaser Image']) === null || _1 === void 0 ? void 0 : _1.Value) || ((_3 = (_2 = document.Fields) === null || _2 === void 0 ? void 0 : _2.Image) === null || _3 === void 0 ? void 0 : _3.Value);
                return (h(Teaser, { key: `${filterType}-${i}`, slot: "teasers", layout: teaserLayout, "teaser-type": type, "teaser-image": image, "teaser-title": title, "teaser-description": description, "teaser-url": (_5 = (_4 = document.Fields) === null || _4 === void 0 ? void 0 : _4.Url) === null || _5 === void 0 ? void 0 : _5.Value, "teaser-date": date, "teaser-overline": date, "is-download-link": isDownloadTeaser, "is-search-result": isSearchResultTeaser }));
            })), h("roche-pagination", { class: {
                    'search-pagination': true,
                    'search-pagination--eight-columns': teaserContainersMap[filterType] !== teaserContainersMap[CludoCategory.STORIES],
                }, activePage: this.currentPage || 1, totalPages: totalPages, style: { display: totalPages > 1 ? 'block' : 'none' }, "data-tab-index": index, "data-rpp": this.resultsPerPage })));
        }))));
    }
    buildSearchQueries() {
        const { cludoCustomerId, cludoEngineId, locale, websiteName, cludoFuzziness, } = DomService.getGlobalConfig();
        // Use cludo fuzzyness only if there are special characters in the query term
        // eslint-disable-next-line no-control-regex
        const hasSpecialCharacters = /[^\x00-\x7F]/.test(this.searchTerm);
        let fuzziness;
        if ((cludoFuzziness === null || cludoFuzziness === void 0 ? void 0 : cludoFuzziness.toUpperCase()) === FuzzinessOption.ON) {
            fuzziness = true;
        }
        else if ((cludoFuzziness === null || cludoFuzziness === void 0 ? void 0 : cludoFuzziness.toUpperCase()) === FuzzinessOption.OFF) {
            fuzziness = false;
        }
        else {
            fuzziness = hasSpecialCharacters;
        }
        return this.searchFilters
            .map((filter) => () => fetch(`https://api.cludo.com/api/v3/${cludoCustomerId}/${cludoEngineId}/search`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `SiteKey ${btoa(`${cludoCustomerId}:${cludoEngineId}:SiteKey`)}`,
            },
            body: JSON.stringify({
                query: fuzziness ? `${this.searchTerm}~` : `${this.searchTerm}`,
                perPage: this.resultsPerPage,
                page: this.currentPage || 1,
                enableFacetFiltering: true,
                filters: {
                    Category: [filter],
                    WebsiteName: [websiteName],
                    Lang: [locale],
                },
            }),
        })
            .then((response) => response.json())
            // eslint-disable-next-line no-console
            .catch((error) => { console.log(error); }));
    }
    async querySearch() {
        this.isLoading = true;
        try {
            this.searchResults = await Promise.all(this.buildSearchQueries().map((request) => request()));
            this.totalResultsFound = this.searchResults.map((result) => result.TotalDocument || 0);
            this.updateSearchParams();
            this.isLoading = false;
            this.trackSearch();
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error('An error occurred during the search:', error);
        }
    }
    trackSearch() {
        const filterData = this.searchFilters.reduce((acc, filter, index) => (Object.assign(Object.assign({}, acc), { [filter]: this.totalResultsFound[index] })), {
            term: this.searchTerm,
            moreData: this.searchResults,
            searchComponent: this.trackingSearchComponent,
            filter: {
                pagination: this.currentPage,
                filter: this.currentSearchFilter,
            },
        });
        AdobeTracking(filterData, 'onsiteSearch');
        if (this.oldQuery === this.searchTerm) {
            return;
        }
        this.oldQuery = this.searchTerm;
        TrackingService.push(Object.assign(Object.assign({}, this.defaultTracking), { value: this.searchTerm }));
    }
    async handleChange(source) {
        var _a, _b;
        // Update trackingSearchComponent based on the source of the search
        this.trackingSearchComponent = source === 'suggestion' ? 'Search Suggestion' : 'Main Search';
        this.searchTerm = (_b = (_a = this.inputElement) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.trim();
        this.currentPage = 1;
        this.searchResults = [];
        this.totalResultsFound = [];
        if (!this.searchTerm) {
            return;
        }
        try {
            await this.querySearch();
        }
        catch (error) {
            console.error('An error occurred during the search:', error);
        }
    }
    handleClearInput() {
        this.inputElement.value = '';
        this.searchTerm = '';
        this.searchResults = [];
        this.totalResultsFound = [];
        this.inputElement.focus();
    }
    getResultsFoundText(tabIndex) {
        return (this.totalResultsFoundText || StringService.capitalize(this.translations.resultsFound))
            .replace(/\$0/g, `${this.totalResultsFound[tabIndex]}`);
    }
    async getTranslatedSearchFilters() {
        return this.searchFilters
            .reduce(async (container, filter) => (Object.assign(Object.assign({}, await container), { [filter]: await TranslationService.translate(filter) })), {});
    }
    get defaultTracking() {
        return {
            event: 'search_typing',
            component_name: 'roche-search',
            additionalParameters: {
                searchResults: this.searchFilters
                    .reduce((a, v, i) => {
                    // eslint-disable-next-line no-param-reassign
                    a[v] = this.totalResultsFound[i];
                    return a;
                }, {}),
            },
        };
    }
    get element() { return this; }
    static get style() { return RocheSearchStyle0; }
}, [1, "roche-search", {
        "totalResultsFoundText": [1, "total-results-found-text"],
        "inputPlaceholder": [1, "input-placeholder"],
        "searchFilters": [16],
        "searchTerm": [32],
        "searchResults": [32],
        "totalResultsFound": [32],
        "isLoading": [32],
        "resultsPerPage": [32],
        "oldQuery": [32],
        "translations": [32],
        "currentPage": [32],
        "currentSearchFilter": [32],
        "trackingSearchComponent": [32],
        "hasLoadedPreviously": [32],
        "isTabChanging": [32]
    }, [[0, "rochePaginationPageChange", "triggerNewPage"], [0, "rocheTabChange", "handleToggle"], [0, "rochePopularSearchTermClick", "triggerPopularSearch"]]]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-search", "roche-accordion-tabs", "roche-accordion-tabs-item", "roche-anchor", "roche-headline", "roche-icon", "roche-loading-spinner", "roche-pagination", "roche-richtext"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-search":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheSearch$1);
            }
            break;
        case "roche-accordion-tabs":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "roche-accordion-tabs-item":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "roche-anchor":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "roche-headline":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "roche-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "roche-loading-spinner":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "roche-pagination":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "roche-richtext":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const RocheSearch = RocheSearch$1;
const defineCustomElement = defineCustomElement$1;

export { RocheSearch, defineCustomElement };

//# sourceMappingURL=roche-search.js.map